module.exports = __webpack_public_path__ + "static/img/mqrcodes.03194ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mqrcodes.png
// module id = 60
// module chunks = 0